export default __webpack_public_path__ + "static/media/demolitioninist.47ed0937.png";